import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }

import {ref} from "vue";
  import {Input} from "@/components/ui/input";
  import { Eye, EyeOff } from 'lucide-vue-next'
  import {useVModel} from "@vueuse/core";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordInput',
  props: {
    placeholder: {},
    defaultValue: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

  const isPasswordVisible = ref(false);

  const props = __props

  const emits = __emit

  const modelValue = useVModel(props, 'modelValue', emits, {
    passive: true,
    defaultValue: props.defaultValue,
  })

  const togglePasswordVisibility = (value: boolean) => {
    isPasswordVisible.value = value;
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Input), {
      modelValue: _unref(modelValue),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(modelValue) ? (modelValue).value = $event : null)),
      id: "password",
      placeholder: props.placeholder,
      type: isPasswordVisible.value ? 'text' : 'password',
      "auto-correct": "off",
      class: "pr-12"
    }, null, 8, ["modelValue", "placeholder", "type"]),
    _createElementVNode("div", {
      class: "cursor-pointer absolute inset-y-0 right-0 flex items-center px-2 rounded-r-md bg-gray-100 border border-l-gray-200",
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (togglePasswordVisibility(!isPasswordVisible.value)), ["prevent"]))
    }, [
      (isPasswordVisible.value)
        ? (_openBlock(), _createBlock(_unref(EyeOff), {
            key: 0,
            class: "h-5 w-5 text-black"
          }))
        : (_openBlock(), _createBlock(_unref(Eye), {
            key: 1,
            class: "h-5 w-5 text-black"
          }))
    ])
  ]))
}
}

})